<template>
  <main class="bmd-layout-content">
    <div class="container">
      <p>Main content</p>
      <p class="float-right">ADMIN</p>
    </div>
  </main>
</template>

<script>
    export default {
        name: "admin"
    }
</script>

<style scoped lang="scss">
  .bmd-layout-content {
    min-height: 90vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/privada/admin/admin.vue